import { Module } from "wrapper6";
import Swiper from 'swiper/bundle';

var $ = jQuery;

export default class ProductSlider extends Module {
    
    ready(app) {
        const SWIPER = new Swiper('.mtt-product-loop .swiper-container', {
            slidesPerView: 1.2,
            speed: 800,
            spaceBetween: 0,
            freeMode: false,
            watchOverflow: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                371: {
                    slidesPerView: 1.5
                },
                651: {
                    slidesPerView: 2
                },
                901: {
                    slidesPerView: 3
                },
                1201: {
                    slidesPerView: 4
                }
            },
            observer: true,
            observeParents: true
        });
    }
}